import React from 'react';
import PrestacaoPcArquivos from './PrestacaoPcArquivos';
import { labelTextClass, strongTextClass, type SectionProps } from './shared';

/** Relatório fotográfico da PC final/única: fotos da execução do objeto. Não é obrigatório. */
const PrestacaoFotosSection: React.FC<SectionProps> = ({ pcId, podeEditar, onAlterado }) => (
  <div className="space-y-4">
    <h2 className={`text-lg font-semibold ${strongTextClass}`}>Relatório fotográfico</h2>
    <p className={`text-sm ${labelTextClass}`}>
      Anexe fotos da execução do objeto. Opcional — disponível apenas na prestação de contas final/única.
    </p>
    <PrestacaoPcArquivos pcId={pcId} tipo="FOTO_EXECUCAO" podeEditar={podeEditar} accept="image/*"
      botao="Anexar foto" multiplos onChange={onAlterado} />
  </div>
);

export default PrestacaoFotosSection;
